import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';

@Component({
    selector: 'p-field-slide-toggle',
    template: ` <p-field
        [isMandatory]="isMandatory"
        [label]="label"
        [labelTooltip]="labelTooltip"
        [isReadOnly]="isReadOnly"
        [customClasses]="customClasses"
        [shouldShowLabel]="shouldShowLabel"
        [shouldTransformLabelTextCase]="shouldTransformLabelTextCase"
        [labelOnLeft]="labelOnLeft"
    >
        <p-slide-toggle
            slot="readMode"
            [checked]="value"
            [disabled]="true"
            [labelOff]="toggleOffText"
            [labelOn]="toggleOnText"
        ></p-slide-toggle>

        <p-slide-toggle
            slot="editMode"
            [checked]="value"
            [labelOff]="toggleOffText"
            [labelOn]="toggleOnText"
            (toggleChanged)="changeValue($event)"
        ></p-slide-toggle>
    </p-field>`,
    styleUrls: ['./p-field-slide-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pFieldSlideToggle',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldSlideToggleComponent
        }
    ]
})
export class PFieldSlideToggleComponent extends PFieldAbstractComponent<boolean> {
    @Input() label?: string;
    @Input() isMandatory = false;
    @Input() textCustomClass?: string;
    @Input() labelOnLeft? = true;
    @Input() customClasses?: string;
    @Input() shouldShowLabel = true;
    @Input() toggleOffText: string = 'No';
    @Input() toggleOnText: string = 'Yes';

    get classes(): object {
        return {
            textCustomClass: true
        };
    }

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    changeValue(value: boolean) {
        this.markAsTouched();

        if (!this.isReadOnly) {
            this.value = value;
            this._onChange(value);
        }
    }
}
